module.exports = __webpack_public_path__ + "img/one_side_cmp_bg.3ad067da.png";